module.exports = __webpack_public_path__ + "./docs/img/icon-php.65370bb6c6581fbe8afbf0c888fac3a1.svg";